const apiRoutes = {
  user: {
    findAll: '/users',
    login: '/users/login',
    register: '/users/register',
    updateAvatar: '/users/update-avatar',
    updateProfile: '/users/update-profile',
    updatePassword: '/users/update-password',
    getMe: '/users/get-me',
    sendVerifyEmail: '/users/send-verify-email',
    verifyEmail: '/users/verify-email',
    sendForgotPasswordEmail: '/users/send-forgot-password-email',
    checkCode: '/users/check-code',
    resetPassword: '/users/reset-password',
    acceptCondition: '/users/accept-condition',
    createUser: '/users/create',
    updateUser: '/users/update',
    changeStatus: '/users/change-status',
    deleteUser: '/users',
  },
  subscription: {
    checkout: '/subscriptions/checkout',
    pause: '/subscriptions/pause',
    resume: '/subscriptions/resume',
    schedule: '/subscriptions/schedule',
    cancelSchedule: '/subscriptions/cancel-schedule',
  },
  billing: {
    default: '/billings',
  },
  interdemField: {
    default: '/interdem-fields',
    update: '/interdem-fields/:id',
  },
  dataset: {
    upload: '/dataset/upload',
  },
  datasetHistory: {
    default: '/dataset-history',
  },
  dataControl: {
    default: '/data-control',
  },
  interdem: {
    default: '/interdem',
    change: '/interdem/change',
    download: '/interdem/download',
    saveScenario: '/interdem/save-scenario',
    saveScenarioFile: '/interdem/save-scenario-file',
    queryFileUpload: '/interdem/query-upload',
    changeFileUpload: '/interdem/change-upload',
  },
  setup: {
    forecastYear: '/setups/forecast-year',
  },
  scenario:{
    uploadData: '/interdem/upload-scenatio-new',
  },
};

export default apiRoutes;
